import { Node, useUpdateNodeInternals, useViewport } from "@xyflow/react";
import { memo, useEffect, useRef } from "react";
import { NodeData, ZOOM_THRESHOLD_COMBINE } from "./flow-step-node";

export const ZoomUpdater = memo(function ZoomUpdater({
  nodes,
}: {
  nodes: Node<NodeData>[];
}) {
  const { zoom } = useViewport();
  const updateNodeInternals = useUpdateNodeInternals();
  const prevZoomRef = useRef(zoom);
  const nodesRef = useRef(nodes);

  useEffect(() => {
    const prevZoom = prevZoomRef.current;
    const currentZoom = zoom;

    const prevCombined = prevZoom < ZOOM_THRESHOLD_COMBINE;
    const currentCombined = currentZoom < ZOOM_THRESHOLD_COMBINE;

    if (prevCombined !== currentCombined) {
      for (const node of nodesRef.current) {
        updateNodeInternals(node.id);
      }
    }

    prevZoomRef.current = currentZoom;
  }, [zoom, updateNodeInternals]);

  return null;
});
